import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authTokenState } from "features/auth/state/authAtoms";
import { studyHistoryLoadingState, studyHistoryState } from "features/optimization/state/studyAtoms";
import { apiRenderKeyState } from "shared/state/renderKeyAtoms";
import { fetchStudyHistory } from "features/optimization/api/fetchStudyHistory";

export const useFetchStudyHistory = () => {
  const setStudyHistoryList = useSetRecoilState(studyHistoryState);
  const setStudyHistoryLoading = useSetRecoilState(studyHistoryLoadingState);
  const authToken = useRecoilValue(authTokenState);
  const renderKey = useRecoilValue(apiRenderKeyState);

  // 履歴取得中のアンマウントを考慮してロードする
  useEffect(() => {
    let cancelled = false;

    const loadStudyHistory = async () => {
      if (authToken === '') {
        setStudyHistoryLoading(false);
        return;
      }

      setStudyHistoryLoading(true);
      try {
        const history = await fetchStudyHistory(authToken);
        if (history && !cancelled) setStudyHistoryList(history);
      } finally {
        if (!cancelled) setStudyHistoryLoading(false);
      }
    };

    loadStudyHistory();
    return () => { cancelled = true; };
  }, [authToken, renderKey, setStudyHistoryList, setStudyHistoryLoading]);
};
